var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('EKAside'),_c('EkNavbar'),_c('v-main',{staticClass:"light"},[_c('transition',{attrs:{"transition":"v-scroll-y-transition"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }